/**
 * Generates the notification warning for extra packages in the cross-selling section..
 *
 * @param product
 * @return {string}
 */
export default (product) => {
    // SSL and Uptime monitoring do not have extra package.
    if ([1, 4].includes(product?.product_id)) {
        return `Add-ons to enhance ${product?.product_name} features`;
    }
};
